"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const i=require("./index269.js");require("./index5.js");const u=require("@apollo/client");function s(e){const t=Object.create(null,{[Symbol.toStringTag]:{value:"Module"}});if(e){for(const n in e)if(n!=="default"){const r=Object.getOwnPropertyDescriptor(e,n);Object.defineProperty(t,n,r.get?r:{enumerable:!0,get:()=>e[n]})}}return t.default=e,Object.freeze(t)}const c=s(u);var a,m={},o=u.gql(a||(a=i.default([`
  mutation createInviteTeamMemberRequest(
    $input: CreateInviteTeamMemberRequestInput!
  ) {
    createInviteTeamMemberRequest(input: $input) {
      success
    }
  }
`])));function l(e){var t=Object.assign({},m,e);return c.useMutation(o,t)}exports.CreateInviteTeamMemberRequestDocument=o;exports.useCreateInviteTeamMemberRequestMutation=l;
